import script from "./UnsupportedWebCompanionPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UnsupportedWebCompanionPage.vue?vue&type=script&setup=true&lang=js"

import "./UnsupportedWebCompanionPage.vue?vue&type=style&index=0&id=52f8db97&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f8db97"]])

export default __exports__